import { render } from "./BgRefundServiceCharge.vue?vue&type=template&id=4249104a&scoped=true"
import script from "./BgRefundServiceCharge.vue?vue&type=script&lang=js"
export * from "./BgRefundServiceCharge.vue?vue&type=script&lang=js"

import "./BgRefundServiceCharge.vue?vue&type=style&index=0&id=4249104a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4249104a"

export default script